import PrivateRoute from "../../components/PrivateRoute";


const ProtectedRoute = ({ children }) => {
  return <PrivateRoute>{children}</PrivateRoute>;
};

export default ProtectedRoute;